// javascript
// app/javascript/controllers/p220/chat_form_controller.js
//
// P220-specific chat form controller.
// Difference from dae20 chat-form: Enter sends (not Ctrl+Enter).
// Shift+Enter inserts a newline.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit"]

  connect() {
    this.inputTarget.addEventListener("keydown", this._handleKeydown.bind(this))

    this.element.addEventListener("submit", () => {
      this.submitTarget.disabled = true
      this.submitTarget.classList.add("opacity-60")
    })

    // Auto-resize on connect
    this.autoResize()

    // Focus input when connected
    this.inputTarget.focus()
  }

  _handleKeydown(e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault()
      // Don't submit empty messages
      if (this.inputTarget.value.trim() !== "") {
        this.element.requestSubmit()
      }
    }
  }

  autoResize() {
    const el = this.inputTarget
    el.style.height = "auto"
    el.style.height = Math.min(el.scrollHeight, 150) + "px"
  }
}
